"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Subtitle2: function() {
        return _Subtitle2.Subtitle2;
    },
    subtitle2ClassNames: function() {
        return _useSubtitle2Stylesstyles.subtitle2ClassNames;
    }
});
const _Subtitle2 = require("./Subtitle2");
const _useSubtitle2Stylesstyles = require("./useSubtitle2Styles.styles");
